module.exports = __webpack_public_path__ + "static/media/Galdisa_Ficha_Pistachios.abe108e7.pdf";